const api = {
  GET_LIST_OUTLET_MANAGEMENT: '/index.php?r=api/v1/outlet/management/index',
  CHANGE_MERCHANT: '/index.php?r=api/v1/outlet/management/change-merchant',
  MOVE_MERCHANT: '/index.php?r=api/v1/outlet/management/move-merchant',
  VIEW_MERCHANT: '/index.php?r=api/v1/outlet/management/view-merchant',
};

export default api;